import * as yup from "yup";
import i18n from "@lib/i18n";
import getByteLength from "@cores/getByteLength";

/**
 * Array unique validation method for yup
 * 배열 내 중복 값을 검증하고, 중복된 값의 인덱스를 반환합니다.
 *
 * yup.array().unique("Duplicate value.", (v) => v)
 */
yup.addMethod(yup.array, "unique", function (message, mapper = (a) => a) {
    return this.test("unique", message, function (list) {
        const mappedArray = list.map(mapper);
        const set = new Set(mappedArray);
        if (set.size !== mappedArray.length) {
            const duplicateIndexes = [];
            const valueCount = {};
            mappedArray.forEach((value, index) => {
                if (!value) return;

                if (!valueCount[value]) {
                    valueCount[value] = { count: 1, indexes: [index] };
                } else {
                    valueCount[value].count += 1;
                    valueCount[value].indexes.push(index);
                }
            });

            for (const value in valueCount) {
                if (valueCount[value].count > 1) {
                    duplicateIndexes.push(...valueCount[value].indexes);
                }
            }
            // 중복된 값의 인덱스를 반환합니다.
            return this.createError({
                path: `${duplicateIndexes}`,
                message: i18n.t(`common::msg::Already exists. Try something else.`, `Already exists. Try something else.`),
            });
        }
        return true;
    });
});

yup.addMethod(yup.string, "maxBytes", function (max, message) {
    return this.test({
        name: "maxBytes",
        message: message || (() => i18n.t(`common::msg::This field can be up to {{maxByte}} bytes.`, `This field can be up to {{maxByte}} bytes.`, { maxByte: max })),
        params: { maxBytes: max },
        test: function (value) {
            if (!value) return true;
            const byteLength = getByteLength(value);

            if (byteLength > max) {
                return this.createError({
                    message: message || i18n.t(`common::msg::This field can be up to {{maxByte}} bytes.`, `This field can be up to {{maxByte}} bytes.`, { maxByte: max }),
                    path: this.path,
                });
            }
            return true;
        },
    });
});

yup.addMethod(yup.string, "minBytes", function (min, message) {
    return this.test({
        name: "minBytes",
        message: message || (() => i18n.t(`common::msg::This field can be at least {{minByte}} bytes.`, `This field can be at least {{minByte}} bytes.`, { minByte: min })),
        params: { minBytes: min },
        test: function (value) {
            if (!value) return true;
            const byteLength = getByteLength(value);
            if (byteLength < min) {
                return this.createError({
                    message: message || i18n.t(`common::msg::This field can be at least {{minByte}} bytes.`, `This field can be at least {{minByte}} bytes.`, { minByte: min }),
                    path: this.path,
                });
            }
            return true;
        },
    });
});

export default yup;
